var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","width":"500"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',{attrs:{"color":"light_gray"}},[_c('v-card-text',{staticClass:"pa-4 def-font"},[_c('div',{staticClass:"text-h5 text-center text-info"},[_vm._v("Saving Data. Please wait...!")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }